export default __webpack_public_path__ + "static/media/cloud-add.75dff76d.svg";